import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NguidPattern } from 'app/services/agency-info.service';

@Component({
  selector: 'app-feat-config-nguid',
  templateUrl: './feat-config-nguid.component.html',
  styleUrls: ['./feat-config-nguid.component.css']
})
export class FeatConfigNguidComponent implements OnInit {

	@Input() calculateOnly?: boolean;
	@Input() discrepancyAgencyId: string;
	@Input() nguidPattern: NguidPattern = {};

	@Output() changePattern: EventEmitter<NguidPattern> = new EventEmitter();
	@Output() onClickCompute: EventEmitter<any> = new EventEmitter();
	constructor() { }

	onChangePattern() {
		this.changePattern.emit(this.nguidPattern);
	}
	clickCompute() {
		this.onClickCompute.emit();
	}
	ngOnInit() {
	}

}
